import React, { useEffect, useState } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../env";
import { useNavigate } from "react-router-dom";

const MediaUploadVideoList = ({ onAction, refresh }) => {
  const [videos, setVideos] = useState([]);
  const navigate = useNavigate(); 

  const loadVideos = async () => {
    const res = await axios.get(
      `${REACT_APP_API_URL}api/dashboard/admin/list-all-videos?mode=all`
    );
    setVideos(res.data.data || []);
  };

  useEffect(() => { loadVideos(); }, []);

  const deleteVideo = async (id) => {
    if (!window.confirm("Delete this video?")) return;
    await axios.delete(`${REACT_APP_API_URL}api/dashboard/admin/delete-video/${id}`);
    loadVideos();
  };

  const changeStatus = async (id, status) => {
    await axios.put(`${REACT_APP_API_URL}api/dashboard/admin/video-status/${id}`, {
      bitStatus: status
    });
    loadVideos();
  };
  

  return (
    <div className="container">

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>ID</th>
            <th>Label</th>
            <th width="260">Actions</th>
          </tr>
        </thead>
        <tbody>
          {videos.map(v => (
            <tr key={v.intVideoID}>
              <td>{v.intVideoID}</td>
              <td>{v.vchLabel || "-"}</td>
              <td className="d-flex gap-2">
                <button
                    className="btn btn-primary btn-sm"
                    onClick={() => onAction("view", v)}
                    >
                    View
                    </button>

                    <button
                    className="btn btn-warning btn-sm"
                    onClick={() => onAction("edit", v)}
                    >
                    Edit
                    </button>

                    <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => onAction("status", v)}
                    >
                    Toggle Status
                    </button>

                    <button
                    className="btn btn-danger btn-sm"
                    onClick={() => onAction("delete", v)}
                    >
                    Delete
                    </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MediaUploadVideoList;
